import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useDemystifyMenuFeatureFlag from 'shared/app/hooks/use-demystify-menu-feature-flag';
import { fetchPricingRules } from '../../../state/actions/pricing-rules';
import { fetchPricingByStore } from '../../../state/actions/pricing-by-store';
import {
  shouldFetchPricingRulesSelector,
  shouldFetchPricingByStoreSelector,
} from '../../../state/selectors';

export const useFetchPricingMetadata = () => {
  const { isDemystifyMenuPdpEnabled } = useDemystifyMenuFeatureFlag();
  const dispatch = useDispatch();

  const shouldFetchPricingRules = useSelector(shouldFetchPricingRulesSelector);
  const shouldFetchPricingByStore = useSelector(
    shouldFetchPricingByStoreSelector
  );

  useEffect(() => {
    if (isDemystifyMenuPdpEnabled && shouldFetchPricingRules) {
      dispatch(fetchPricingRules());
    }
  }, [isDemystifyMenuPdpEnabled, shouldFetchPricingRules]);

  useEffect(() => {
    if (isDemystifyMenuPdpEnabled && shouldFetchPricingByStore) {
      dispatch(fetchPricingByStore());
    }
  }, [isDemystifyMenuPdpEnabled, shouldFetchPricingByStore]);

  return {};
};
